import experiment from 'experiment';
import type { SlotOpenerScope } from '../scope';
import { findAvailableSlot } from './findAvailableSlot';
import { findAvailableSlotV2 } from './findAvailableSlotV2';
import { findAvailableSlotV3 } from './findAvailableSlotV3';
import { getAllSlotsForComponent, getAllSlotsInContainer } from './getSlots';
import { openSlotAndPositionComp, openSlot, getCompPosition } from './openSlot';

export const createSlotOpenerPrivateApi = (scope: SlotOpenerScope) => {
  const bindScope =
    <T extends any[], K>(fn: (scope: SlotOpenerScope, ...args: T) => K) =>
    (...args: T): K =>
      fn(scope, ...args);

  return {
    getAllSlotsInContainer: bindScope(getAllSlotsInContainer),
    getAllSlotsForComponent: bindScope(getAllSlotsForComponent),
    // eslint-disable-next-line no-nested-ternary
    findAvailableSlot: experiment.isOpen('se_slotOpenerV3')
      ? findAvailableSlotV3
      : experiment.isOpen('se_slotOpenerV2')
        ? findAvailableSlotV2
        : findAvailableSlot,
    openSlotAndPositionComp: bindScope(openSlotAndPositionComp),
    openSlot: bindScope(openSlot),
    getCompPosition: bindScope(getCompPosition),
  };
};
